import { gql } from "@apollo/client/core";

export const LAWCASE_CLIENT_FOLDER_QUERY = gql`
  query ($lawcaseId: ID!, $folderId: ID!) {
    lawcaseClient(lawcaseId: $lawcaseId) {
      id
      title
      description
      folders {
        id
        name
        parentId
      }
      folder(folderId: $folderId) {
        id
        name
        parentId
        documents {
          id
          title
          hasRead
          description
          filePath
          fileExtension
          thumbnailSource
          clientId
          isLocked
        }
        folders(rootFolderId: $folderId) {
          id
          name
          parentId
        }
      }
    }
  }
`;

export const CLIENT_UPDATE_DOCUMENT_MUTATION = gql`
  mutation ($lawcaseId: ID!, $documentId: ID!, $params: InputDocumentParams!) {
    updateDocumentClient(
      lawcaseId: $lawcaseId
      documentId: $documentId
      params: $params
    ) {
      id
      title
      description
    }
  }
`;

export const CLIENT_DELETE_DOCUMENT_MUTATION = gql`
  mutation ($lawcaseId: ID!, $documentId: ID!) {
    deleteDocumentClient(lawcaseId: $lawcaseId, documentId: $documentId) {
      id
    }
  }
`;
